import { Routes, Route } from "react-router-dom";

import ShraddhaEvents from "../MemberPages/Events/Events";
import Support from "../MemberPages/support/Support";
import ShraddhaMemeberTV from "../MemberPages/courses/CourseVideo";
import CourseDetail from "../MemberPages/courses/CourseDetilas";
import ShraddhaInfiniteCourses from "../MemberPages/courses/Courses";
import MyCourses from "../MemberPages/courses/MyCourses";
import TrainingVideos from "../MemberPages/Events/TrainingVideos";
import ShraddhaInfinite from "../MemberPages/Events/ShraddhaInfinite";
import WebsiteEvent from "../MemberPages/Events/WebsiteEvent";


const MemberRoutes = () => {
  return (
    <Routes>
      <Route path="/ShraddhaEvents" element={<ShraddhaEvents />} />
      <Route path="/Support" element={<Support />} />
      <Route path="/ShraddhaMemeberTV" element={<ShraddhaMemeberTV />} />
      <Route path="/course-detail" element={<CourseDetail />} />
      <Route path="/ShraddhaCourses" element={<ShraddhaInfiniteCourses />} />
      <Route path="/MyCourses" element={<MyCourses />} />
      <Route path="/EventsRecording" element={<TrainingVideos />} />
      <Route path="/WebsiteEvent" element={<WebsiteEvent />} />
      <Route path="/ShraddhaInfinite" element={<ShraddhaInfinite />} />
    </Routes>
  );
};

export default MemberRoutes;
